import { Skeleton } from "@/components/ui/skeleton"

export default function AuthSkeleton() {
  return (
    <div className="px-4 pb-8" aria-hidden="true">
      <div className="rounded-2xl bg-white shadow-sm border border-gray-100 p-4 relative max-w-lg mx-auto md:px-9 animate-pulse">
        {/* Top gradient accent (kept for visual match) */}
        <div className="absolute left-0 right-0 top-0 h-2.5 rounded-t-[14px] bg-[linear-gradient(90deg,#ff0a7a_0%,#ff1e79_100%)]" />

        <div className="flex flex-col items-center text-center mt-10">
          <Skeleton className="w-16 h-16 rounded-full bg-pink-50 flex items-center justify-center shadow-sm mb-6" />
          <Skeleton className="h-4 w-40 rounded-md mb-2" />
          <Skeleton className="h-3 w-56 rounded-md" />
        </div>

        <div className="mt-6 space-y-4">
          <Skeleton className="h-11 rounded-lg" />
          <Skeleton className="h-11 rounded-lg" />
          <Skeleton className="h-11 rounded-full" />
        </div>

        <div className="mt-4 space-y-2">
          <Skeleton className="h-3 w-full rounded" />
        </div>
      </div>
    </div>
  )
}